export default "__VITE_ASSET__ac24bbd4__"